export const actionKey = '@@GROUPS';
